const NUMBER_FORMAT = new Intl.NumberFormat();
export const EM_DASH = "–";

export function formatAmount(
  amount: number | string | null | undefined,
  currency: string | null,
): string {
  if (amount === null || amount === undefined) return EM_DASH;
  if (typeof amount === "string") amount = parseInt(amount);

  const formatted = NUMBER_FORMAT.format(amount);

  if (!currency) {
    return `${formatted}`;
  } else if (isNaN(amount)) {
    return EM_DASH;
  }
  return `${formatted} ${currency}`;
}

export function formatRecordDate(date: string): string {
  return date.split("-").reverse().join("/");
}

export function capitalizeFirstLetter(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const ELLIPSIS = "…";

export function truncate(text: string, length: number): string {
  if (text.length <= length) {
    return text;
  } else {
    return text.slice(0, length) + ELLIPSIS;
  }
}

export function pluralise(count: number, noun: string, formatNumber?: boolean): string {
  if (count != 1) {
    noun = `${noun}s`;
  }
  return `${formatNumber ? NUMBER_FORMAT.format(count) : count} ${noun}`;
}

// It's ok for the Fn to have any args or return type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AllowedAny = any;

export function debounce<F extends (...args: AllowedAny[]) => AllowedAny>(fn: F, interval: number) {
  let timer: NodeJS.Timeout | undefined = undefined;

  const wrap = ((...args: AllowedAny[]) => {
    clearTimeout(timer);

    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(fn(...args)), interval);
    });
  }) as F;

  return wrap;
}

export const SEO_URLS = {
  signUp: "get-started",
  signIn: "users/sign_in",

  tenderSearch: "/explore/search",
  buyerSearch: "/explore/search/buyers",
  sourceSearch: "/explore/search/sources",
  topicSearch: "/explore/search/topics",
};
